module.exports = __webpack_public_path__ + "1a533125f31480114c49fc471fef5a95.svg";